import { parseISO, formatDistanceToNow, differenceInDays, format } from 'date-fns';

import { DATE_FORMATS } from '@constants/general';

/**
 * Changes and ISO date string to a string describing the distance to now. If the distance is greater than one day it will instead return a date and time.
 * @param {string} date ISO date string
 * @param {string} [prefix=''] String to add to start of return value
 * @returns {string} Distance description
 */
export const formatIsoDistanceToNow = (date, prefix = '') => {
  try {
    const parsedDate = parseISO(date);
    const days = differenceInDays(parsedDate, new Date());
    const displayDate =
      days === 0
        ? formatDistanceToNow(parsedDate, { includeSeconds: true, addSuffix: true })
        : format(parsedDate, DATE_FORMATS.MEDIUM_DATE_TIME);

    return `${prefix}${displayDate}`;
  } catch (e) {
    // Do nothing
  }
};
